import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { NavLink } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';
import "./Header.css"

const Header = () => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Navbar className='navbar-glass' fixed="top">
                <Container>
                    <div className="hamburgur">
                        <i className="fa fa-bars inner large-icon" onClick={handleShow} aria-hidden="true" style={{ cursor: "pointer" }}></i>
                        <h2 className='h2_right'>
                            <NavLink to="/" style={{ textDecoration: "none" }} className="brand-text">Portfolio</NavLink>
                        </h2>
                    </div>

                    <Nav className="nav ms-auto">
                        <div className='d-flex align-items-center'>
                            <NavLink to="/" className={({ isActive }) => isActive ? "text-decoration-none nav-link-custom active" : "text-decoration-none nav-link-custom"}>Home</NavLink>
                            <NavLink to="/skills" className={({ isActive }) => isActive ? "text-decoration-none nav-link-custom active" : "text-decoration-none nav-link-custom"}>Skills</NavLink>
                            <NavLink to="/experience" className={({ isActive }) => isActive ? "text-decoration-none nav-link-custom active" : "text-decoration-none nav-link-custom"}>Experience</NavLink>
                            <NavLink to="/playlist" className={({ isActive }) => isActive ? "text-decoration-none nav-link-custom active" : "text-decoration-none nav-link-custom"}>Projects</NavLink>
                            <NavLink to="/contact" className={({ isActive }) => isActive ? "text-decoration-none nav-link-custom active" : "text-decoration-none nav-link-custom"} style={{ marginRight: 0 }}>Contact</NavLink>
                        </div>
                    </Nav>
                </Container>

                <Offcanvas show={show} onHide={handleClose} className="offcanvas-glass">
                    <Offcanvas.Header closeButton closeVariant="white" style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
                        <Offcanvas.Title className="brand-text h2_right">Menu</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <div className='side_nav' onClick={() => setShow(false)}>
                            <NavLink to="/" className={({ isActive }) => isActive ? "text-decoration-none side-link active" : "text-decoration-none side-link"}>Home</NavLink>
                            <NavLink to="/skills" className={({ isActive }) => isActive ? "text-decoration-none side-link active" : "text-decoration-none side-link"}>Skills</NavLink>
                            <NavLink to="/experience" className={({ isActive }) => isActive ? "text-decoration-none side-link active" : "text-decoration-none side-link"}>Experience</NavLink>
                            <NavLink to="/playlist" className={({ isActive }) => isActive ? "text-decoration-none side-link active" : "text-decoration-none side-link"}>Projects</NavLink>
                            <NavLink to="/contact" className={({ isActive }) => isActive ? "text-decoration-none side-link active" : "text-decoration-none side-link"}>Contact</NavLink>
                        </div>
                    </Offcanvas.Body>
                </Offcanvas>
            </Navbar>
            {/* Add a spacer div to prevent content from hiding under fixed navbar */}
            <div style={{ height: '80px' }}></div>
        </>
    );
}

export default Header;
